module.exports = __webpack_public_path__ + "img/feculents.55fd6164.png";